import * as intelligentGamingService from '@/modules/intelligent-gaming/intelligentGamingService';
import sidHandler from './sequentiality/sidHandler';

export { useIntelligentGamingStore } from './store';
export const init = () => {
  intelligentGamingService.init();
  sidHandler.init();
};
